import type { ReactNode } from 'react'
import { PinTypeCatalogProvider } from '@wehunt/ui'
import { usePinTypeCatalogEntries } from './usePinTypeCatalogEntries'

/**
 * Mounts the pin-type catalog provider fed from Remote Config. The app wraps
 * its routed tree in this once; `@wehunt/ui` never fetches anything itself.
 */
export function PinTypeCatalogHost({ children }: { children: ReactNode }) {
  const { entries, ready } = usePinTypeCatalogEntries()
  return <PinTypeCatalogProvider entries={entries} ready={ready}>{children}</PinTypeCatalogProvider>
}
